



import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import UserService from '@/services/UserService'

@Component({
  name: 'MainIcoachPageTemplate'
})
export default class MainIcoachPageTemplate extends Vue {
  @Prop({})
  accessCode?: string

  @Prop({})
  token?: string

  @Getter('user/isAuthenticated')
  isAuthenticated!: boolean

  async created () {
    await this.checkToken()
  }

  async checkToken (): Promise<void> {
    if (!this.isAuthenticated && this.token && this.accessCode) {
      await this.$auth.setToken({
        'message': 'Icoach user successfully logged in',
        'token': this.token
      })

      try {
        await UserService.getUser()
      } catch (error) {}

      await this.$router.push({
        name: 'icoach.welcome',
        params: {
          accessCode: this.accessCode
        }
      })
    }
  }
}
